import React from "react";
import "./Footer.css";

// set the footer to a copyright string
const Footer = props => (
  <div className="footer">
    <p class="text-muted text-center">All Rights Reserved</p>
  </div>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js